// extracted by mini-css-extract-plugin
module.exports = {"detail":"deduction_detail__2RiSg","field":"deduction_field__DvBj5","verifyButton":"deduction_verifyButton__2hpHl","rejected":"deduction_rejected__26nc8"};